const serviceTerms = [
  {
    id: "overview",
    title: "1. Overview",
    content: "These terms govern the use of EliteCars rental services. By booking and using our vehicles, you agree to comply with the policies outlined in this agreement."
  },
  {
    id: "acceptable-use",
    title: "2. Acceptable Use",
    content: "Vehicles must be used lawfully and responsibly. Misuse, unauthorized driving, reckless behavior, or any illegal activities while using our rental cars are strictly prohibited."
  },
  {
    id: "subscription",
    title: "3. Rental Terms",
    content: "Rental agreements are based on selected durations, vehicle types, and pricing. Payment must be completed before or at the start of the rental period. Late returns may incur additional fees."
  },
  {
    id: "user-obligations",
    title: "4. User Obligations",
    content: "You are responsible for the rented vehicle’s safety and condition. Report accidents, damages, or issues immediately. Always follow local traffic laws and usage guidelines."
  },
  {
    id: "limitation-liability",
    title: "5. Limitation of Liability",
    content: "EliteCars is not liable for personal items lost in vehicles, third-party actions, or any damages caused by misuse or accidents beyond our control, as allowed by law."
  },
  {
    id: "termination",
    title: "6. Termination",
    content: "EliteCars may terminate bookings or refuse service if terms are violated, payments are missed, or the vehicle is misused. In such cases, customers will be notified accordingly."
  },
  {
    id: "intellectual-property",
    title: "7. Intellectual Property",
    content: "All branding, logos, and content on the EliteCars platform are our intellectual property. Unauthorized use or reproduction is strictly prohibited without prior written consent."
  },
  {
    id: "governing-law",
    title: "8. Governing Law",
    content: "These terms are governed by the laws of the applicable region. Any disputes will be handled under the legal jurisdiction where the rental was made."
  },
  {
    id: "contact-info",
    title: "9. Contact Information",
    content: "For questions about our terms, contact us at support@elitecars.com or call +123-456-7890. We’re here to help 24/7."
  }
];

export default serviceTerms;